import * as React from 'react';
import { createGlobalStyle } from 'styled-components';
import Collapsible from '../../components/Collapsible';
import MyData from '../datos';
import Income from '../ingresos';
import Expenses from '../egresos';
import SavingsAndDebts from '../ahorrosYDeudas';
import AdditionalInformation from '../informacionAdicional';
import Health from '../salud';
import LivingPlace from '../vivienda';
import { Container, Title, Subtitle, BackButtonContainer } from './styled';
import Processing from '@/presentation/components/Processing';
import Spinner from '../../../../../../../components/Spinner';
import Snackbar from '../../../../../../../components/Snackbar';
import FamilyForm from '../family';
import ModuleContainer from '@/presentation/components/Container';
import Back from '@/presentation/reusables/Button/Back';

export const StylesCollapse = createGlobalStyle`
  @keyframes slide-in {
  0% {overflow: hidden}
  100% {overflow:visible;}
  }

  .toggle-content {
    height: 0;
    overflow: hidden;
    transition: height 0.4s ease-in-out;
    }
    .toggle-content.expanded {
      height: calc-size(auto, size);
      animation-duration: 1s;
      animation-name: slide-in;
      overflow: visible;
    }`;

interface IndexViewProps {
  isLoadingData: boolean;
  isSaving: boolean;
  formData: any;
  formFamily: any;
  formIncome: any;
  formExpenses: any;
  formSavingsAndDebts: any;
  formLivingPlace: any;
  formHealth: any;
  formAdditionalInformation: any;
  handleNext: (index: number) => void;
  handleBackButton: () => void;
  handleSave: (
    formName: string,
    fields: any,
    isComplete: boolean,
    save: boolean
  ) => void;
  idRequest: number;
  fieldsSnackbar: any;
  isMarried: boolean | string;
}

const IndexView = (props: IndexViewProps) => {
  const {
    isLoadingData,
    isSaving,
    idRequest,
    formData,
    formFamily,
    formIncome,
    formExpenses,
    formSavingsAndDebts,
    formLivingPlace,
    formHealth,
    formAdditionalInformation,
    handleBackButton,
    handleSave,
    handleNext,
    fieldsSnackbar
  } = props;

  const [execCallback, setExecCallback] = React.useState(0);

  const saveFamilyCallback = () => {
    setExecCallback(execCallback + 1);
  };

  return (
    <ModuleContainer
      containerType="subsection"
      data-testid="cmp-bse-form-index-view"
    >
      <StylesCollapse />
      {/* cambiar a isSaving */}
      <Processing isOpen={isSaving} />
      <BackButtonContainer>
        <Back
          dataTestid="cmp-buttom-back-refactor"
          onClick={handleBackButton}
        />
      </BackButtonContainer>
      <Container>
        <Title>Completar formularios</Title>
        <Subtitle>
          Ingresa tus datos, de acuerdo a las siguientes categorías solicitadas.
        </Subtitle>
        <Subtitle className="highlight">
          Solo algunos datos son opcionales.
        </Subtitle>
        {isLoadingData ? (
          <Spinner />
        ) : (
          <>
            <Collapsible {...formData}>
              <MyData
                data-testid="bse-form-myData"
                idRequest={idRequest}
                save={handleSave}
                saveCallback={saveFamilyCallback}
                next={() => handleNext(formData.index)}
              />
            </Collapsible>
            <Collapsible {...formFamily}>
              <FamilyForm
                idRequest={idRequest}
                save={handleSave}
                next={() => handleNext(formFamily.index)}
              />
            </Collapsible>
            <Collapsible {...formIncome}>
              <Income
                data-testid="bse-form-ingresos"
                idRequest={idRequest}
                save={handleSave}
                next={() => handleNext(formIncome.index)}
              />
            </Collapsible>
            <Collapsible {...formExpenses}>
              <Expenses
                idRequest={idRequest}
                save={handleSave}
                next={() => handleNext(formExpenses.index)}
              />
            </Collapsible>
            <Collapsible {...formSavingsAndDebts}>
              <SavingsAndDebts
                data-testid="bse-savings-and-debts"
                idRequest={idRequest}
                save={handleSave}
                next={() => handleNext(formSavingsAndDebts.index)}
              />
            </Collapsible>
            <Collapsible {...formLivingPlace}>
              <LivingPlace
                idRequest={idRequest}
                save={handleSave}
                next={() => handleNext(formLivingPlace.index)}
              />
            </Collapsible>
            <Collapsible {...formHealth}>
              <Health
                data-testid="bse-form-salud"
                idRequest={idRequest}
                save={handleSave}
                next={() => handleNext(formHealth.index)}
              />
            </Collapsible>
            <Collapsible {...formAdditionalInformation}>
              <AdditionalInformation
                data-testid="bse-form-informacion-adicional"
                idRequest={idRequest}
                save={handleSave}
                next={() => handleNext(formAdditionalInformation.index)}
              />
            </Collapsible>
            <div style={{ width: '100%', height: '30px' }} />
            <div
              style={{
                width: '100%',
                position: 'fixed',
                bottom: '1rem',
                left: 0
              }}
            >
              <Snackbar timeout={5000} fieldsSnackbar={fieldsSnackbar} />
            </div>
          </>
        )}
      </Container>
    </ModuleContainer>
  );
};

export default IndexView;
